export enum UserManagementColumns {
  logo = 'logo',
  name = 'name',
  email = 'email',
  phoneNo = 'phoneNo',
  organisation = 'organisation',
  organisationType = 'organisationType',
  status = 'status',
  role = 'role',
  actions = 'actions',
}
